<template>
  <div class="watch-video-player">
    <video autoplay muted crossorigin :id="id" :poster="poster"></video>
    <div class="shadow"></div>
    <button
      @click="changeVolume(actualVolume == 0 ? 100 : 0)"
      class="btn volume-btn"
    >
      <img
        src="@/assets/images/icons/volume-mute.svg"
        v-if="actualVolume == 0"
      />
      <img src="@/assets/images/icons/volume-full.svg" v-else />
    </button>
  </div>
</template>

<script>
  import Hls from "hls.js";
  import Plyr from "plyr";
  import "plyr/dist/plyr.css";
  // import Comments from "./Comments";

  // import { mapState } from "vuex";
  // import { getMoment } from "@/functions.js";

  export default {
    props: {
      id: {
        type: [String, Number],
        required: true,
      },
      season: {
        type: Object,
        required: () => {},
      },
      title: {
        type: String,
        default: "",
      },
      src: {
        type: String,
        required: true,
      },
      poster: {
        type: String,
        default: "",
      },
      duration: {
        type: Number,
        default: 0,
      },
      startTime: {
        type: Number,
        default: 0,
      },
      isSerie: {
        type: Boolean,
        default: false,
      },
      content: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        interval: null,
        loadingComments: false,
        player: null,
        hls: null,
        actualVolume: 0,
        actualSubtitle: -1,
        actualIdiom: 0,
        showingComments: false,
        showingEpisodes: false,
        showingVolume: false,
        showingIdiom: false,
        subtitleSize: 1,
        subtitleActive: false,
        audioTracks: null,
        subtitleTracks: null,
      };
    },
    computed: {
      isKids() {
        return this.$user.currentProfile.is_kids;
      },
      episodes() {
        return this.season && this.season.episodes;
      },
      mySubtitles() {
        return this.subtitleTracks && this.subtitleTracks;
      },
      myAudios() {
        return this.audioTracks && this.audioTracks;
      },
    },
    mounted() {
      // this.loadComments();
      window.showComments = this.showComments.bind(this);
      window.showEpisodes = this.showEpisodes.bind(this);
      window.showVolume = this.showVolume.bind(this);
      window.showIdiom = this.showIdiom.bind(this);
      window.nextEpisode = this.nextEpisode.bind(this);
      const video = document.querySelector("video");

      this.player = new Plyr(video, {
        title: "movie",
        debug: false,
        autoplay: true,
        muted: true,
        ratio: "16:9",
        autopause: false,
        volume: 0,
        storage: {
          enabled: false,
        },
      });

      // this.player.toggleCaptions(false);
      if (Hls.isSupported()) {
        var config = {
          xhrSetup: function (xhr, url) {
            xhr.withCredentials = false; // do send cookies - padrao é true, alterei pra testar
          },
          autoStartLoad: false,
        };

        const hls = new Hls(config);
        hls.loadSource(this.src); // https://wowzaec2demo.streamlock.net/vod-multitrack/_definst_/smil:ElephantsDream/elephantsdream2.smil/playlist.m3u
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          hls.startLoad();
        });

        this.hls = hls;
      }

      //this.player.currentTrack = -1;
      //this.player.toggleCaptions(false);
      window._player = this.player;

      var firstPlay = true;
      this.player.on("canplay", () => {
        // if (firstPlay) {
        //   setTimeout(() => {
        //     this.player.currentTime = this.startTime;
        //   }, 1);
        //   firstPlay = false;
        // }
        // this.player.play();
      });

      this.player.on("controlshidden", () => this.$emit("controlshidden"));
      this.player.on("controlsshown", () => this.$emit("controlsshown"));
      this.player.on("volumechange", (event) => {
        // this.updateVolumeComponent();
      });

      // this.player.play();
      // this.player.on("enterfullscreen", () => this.player.toggleControls(false));
      // this.player.on("exitfullscreen", () => this.player.toggleControls(true));

      // setTimeout(() => {
      //   this.player.play();
      // }, 1000);
    },
    beforeUnmount() {
      this.hls.destroy();
      // window._player = null;

      // this.hls = null;
      if (this.player) {
        this.player.destroy();
      }
      clearInterval(this.interval);
    },
    unmounted() {
      clearInterval(this.interval);
    },
    methods: {
      getCodeName(val) {
        switch (val) {
          case "pt-br":
            return "Português";
          case "por":
            return "Português";
          case "pt":
            return "Português Pt";
          case "en":
            return "Inglês";
          case "eng":
            return "Inglês";
          case "es":
            return "Espanhol";
          case "fr":
            return "Francês";
          case "fra":
            return "Francês";
          case "de":
            return "Alemão";
          case "it":
            return "Italiano";
          case "ko":
            return "Koreano";
          case "ro":
            return "Russo";
          case "ja":
            return "Japonês";
          case "zho":
            return "Chinês";
          case "pol":
            return "Polonês";
          default:
            return val;
        }
      },
      nextEpisode() {
        this.episodes.map((ep, index) => {
          if (ep.id == this.id) {
            if (index + 1 < this.episodes.length) {
              this.$emit("next", this.episodes[index + 1]);
            }
          }
        });
      },
      saveDuration({ finished, duration }) {
        this.$store.dispatch("film/setProgress", {
          film: this.id,
          finished_at: finished,
          stopped_at: Math.floor(duration),
        });
      },
      showComments() {
        this.player.fullscreen.exit();
        if (!this.showingComments) {
          setTimeout(() => {
            this.showingComments = true;
          }, 1);
        }
      },
      showEpisodes() {
        this.player.fullscreen.exit();
        if (!this.showingEpisodes) {
          setTimeout(() => {
            this.showingEpisodes = true;
          }, 1);
        }
      },
      showVolume() {
        if (this.player.fullscreen.active) {
          this.player.fullscreen.exit();
        }

        if (!this.showingVolume) {
          setTimeout(() => {
            this.showingVolume = true;
          }, 1);
        }
      },
      showIdiom() {
        this.player.fullscreen.exit();
        if (!this.showingIdiom) {
          setTimeout(() => {
            this.showingIdiom = true;
          }, 1);
        }
      },
      changeIdiom(val) {
        this.hls.audioTrack = val;
        this.actualIdiom = val;
      },
      showSubtitles(lang) {
        //this.player.toggleCaptions(false)
        if (!this.subtitleActive) {
          this.subtitleActive = true;
          // this.loadSubtitles();
          setTimeout(() => {
            this.player.currentTrack = lang;
            this.actualSubtitle = lang;
          }, 100);
        } else {
          this.player.currentTrack = lang;
          this.actualSubtitle = lang;
        }

        //this.player.toggleCaptions(true)
      },
      loadSubtitles() {
        // load all subtitles if select for show first time
        const video = document.querySelector("video");
        //this.subtitles.map(sub => {
        this.mySubtitles.map((sub) => {
          const track = document.createElement("track");
          Object.assign(track, {
            kind: "captions",
            label: sub.lang,
            srclang: sub.lang,
            default: false,
            src: sub.url,
          });
          video.appendChild(track);
        });
      },
      changeVolume(val) {
        this.actualVolume = val;
        this.player.volume = val / 100;
      },
      updateVolumeComponent() {
        if (this.player.muted) {
          this.actualVolume = 0;
        } else {
          this.actualVolume = this.player.volume * 100;
        }

        // if (this.player.volume == 0) {
        //   this.actualVolume = 0;
        // }
      },
      loadComments() {
        this.loadingComments = true;
        this.$store.dispatch("comments/get", { id: this.id }).finally(() => {
          this.renderComments();
          this.loadingComments = false;
        });
      },
      renderComments() {
        const commentCards = document.getElementById(
          "plyr__progress__commentCards"
        );
        const commentMarks = document.getElementById(
          "plyr__progress__commentMarks"
        );
        commentCards.innerHTML = "";
        commentMarks.innerHTML = "";

        this.comments.forEach((comment) => {
          const card = document.createElement("div");
          card.style.left = `${(100 * comment.interval) / this.duration}%`;
          card.innerHTML = comment.text;
          card.style.display = "none";
          commentCards.appendChild(card);

          const button = document.createElement("button");
          button.style.left = `${(100 * comment.interval) / this.duration}%`;
          button.onmouseenter = () => {
            card.style.display = "block";
          };
          button.onmouseleave = () => {
            card.style.display = "none";
          };
          commentMarks.appendChild(button);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .watch-video-player {
    --plyr-color-main: #fff;
    --plyr-video-control-background-hover: rgba(0, 0, 0, 0.1);

    --plyr-control-icon-size: 26px;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 100%;

    @media (max-width: 768px) {
      height: 96vh;
    }

    :deep(.plyr__video-wrapper) {
      @media (max-width: 768px) {
        height: 95vh !important;
      }
    }
    width: 100%;
    .volume-btn {
      position: absolute;
      height: 40px;
      width: 40px;
      bottom: 20%;
      right: 4%;

      @media screen and (max-width: 768px) {
        bottom: 23%;
      }
    }
    .shadow {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        180deg,
        rgba(41, 15, 0, 0) -3.75%,
        #000000 100%
      );
    }
    video {
      width: 100vw;
      object-fit: cover;
      //min-height: 600px;
      //max-height: 600px;
      min-height: 95vh;
      max-height: 95vh;

      // @media (min-width: 1300px) {
      //   min-height: 490px;
      //   max-height: 490px;
      // }

      // @media screen and (min-width: 1800px) {
      //   min-height: 600px;
      //   max-height: 600px;
      // }
      // @media screen and (max-width: 768px) {
      //   height: 80vh;
      //   min-height: 80vh;
      //   max-height: 80vh;
      // }
    }
    // .plyr--video {
    //   height: 100%;
    //   max-height: 100%;
    // }

    :deep(.plyr:not(.plyr--hide-controls)
        .plyr__controls:not(:empty)
        ~ .plyr__captions) {
      transform: translateY(calc(10px * -4));
      transform: translateY(calc(var(--plyr-control-spacing, 25px) * -4));
    }

    &.subtitleSmall {
      :deep(.plyr__captions) {
        font-size: 22px;

        @media screen and (min-width: 1400px) {
          font-size: 27px;
        }

        @media screen and (min-width: 1600px) {
          font-size: 31px;
        }

        @media screen and (min-width: 1700px) {
          font-size: 34px;
        }

        @media screen and (min-width: 1800px) {
          font-size: 37px;
        }

        @media screen and (min-width: 1900px) {
          font-size: 39px;
        }
      }
    }

    :deep(.plyr__captions) {
      z-index: 3;
      line-height: normal;
      color: #fff;
      text-shadow: #000 0px 0px 7px;
      font-weight: bolder;
    }

    &.subtitleNormal {
      :deep(.plyr__captions) {
        font-size: 27px;

        @media screen and (min-width: 1400px) {
          font-size: 32px;
        }

        @media screen and (min-width: 1600px) {
          font-size: 36px;
        }

        @media screen and (min-width: 1700px) {
          font-size: 39px;
        }

        @media screen and (min-width: 1800px) {
          font-size: 42px;
        }

        @media screen and (min-width: 1900px) {
          font-size: 44px;
        }
      }
    }

    &.subtitleLarge {
      :deep(.plyr__captions) {
        font-size: 34px;

        @media screen and (min-width: 1400px) {
          font-size: 39px;
        }

        @media screen and (min-width: 1600px) {
          font-size: 43px;
        }

        @media screen and (min-width: 1700px) {
          font-size: 46px;
        }

        @media screen and (min-width: 1800px) {
          font-size: 48px;
        }

        @media screen and (min-width: 1900px) {
          font-size: 51px;
        }
      }
    }

    &.alwaysShow {
      :deep(.plyr--hide-controls:not(:-webkit-full-screen) .plyr__controls) {
        opacity: 1;
        pointer-events: visible;
        transform: none;
      }
    }
    :deep(.plyr--hide-controls:not(:-webkit-full-screen) .plyr__controls) {
      opacity: 0;
      pointer-events: visible;
      transform: none;
    }

    :deep(.container-progress-control) {
      position: relative;
      width: 100%;
      background: transparent;
      margin-bottom: 3px;
    }

    :deep(.container-controls) {
      position: relative;
      width: 100%;
      background: transparent;
      padding-top: 3px;
    }

    :deep(.title-container) {
      //padding-right: 70%;
      width: 100%;
      text-align: left;
      padding-left: 16px;
    }
    :deep(#plyr__progress__commentMarks) {
      > button {
        position: absolute;
        top: 2px;
        height: 15px;
        background: #a7d039;
        border-radius: 8px;
        width: 4px;
        border: none;
        padding: 0;
        z-index: 3;
      }
    }

    :deep(#plyr__progress__commentCards) {
      > div {
        position: absolute;
        bottom: 0px;
        background: #212631;
        border-radius: 8px;
        max-width: 220px;
        border: none;
        padding: 8px 16px;
        z-index: 3;
        transform: translate(-50%, -32px);

        &::after {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #212631;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    :deep(.plyr__volume) {
      @media screen and (max-width: 575px) {
        width: auto;
        min-width: auto;
      }
    }
  }
</style>
